import * as React from 'react';
import {
  SimpleForm,
  TextInput,
  required,
  Create,
  useRedirect,
} from 'react-admin';

const ActivationCodesCreate = () => {
  const redirect = useRedirect();

  return <Create redirect={'/pendrive/activation-codes'}>
    <SimpleForm>
      <TextInput source="title" validate={[required()]} fullWidth />
      <TextInput source="secret" validate={[required()]} fullWidth />
    </SimpleForm>
  </Create>
};


export default ActivationCodesCreate;